export const LIMIT_TIME = 180000; // 3 minutes (180000ms)
export const MAX_ATTEMPTS = 2;

export const ALLOWED_SOURCES = [
  "community_manager",
  "community_manager_online",
  "administration",
];

export const STORAGE_KEY = "info";

export const META_TITLES = {
  uz: "Öquv markazi | Toşkentdagi Ingliz tili kurslari | IELTS kurslari",
  ru: "УЧЕБНЫЙ ЦЕНТР | Курсы английского языка в Ташкенте | IELTS курсы",
  en: "Öquv markazi | Toşkentdagi Ingliz tili kurslari | IELTS kurslari",
} as const;

export const TRANSLATIONS = {
  uz: {
    name: "Ismingiz",
    phone: "Telefon raqami",
    comment: "Izoh",
    submit: "Yuboriş",
    searchCountry: "Davlatni qidiriş...",
    notFound: "Topilmadi",
    rateLimitError: "Siz faqat 30 daqiqada 2 marta urinişingiz mumkin!",
    titlePart1: "INGLIZ TILI",
    titlePart2: "ni",
    titlePart3: "örganmoqçimisiz?",
    description:
      "U holda raqamingizni qoldiring va biz barça savollaringizga javob beramiz.",
  },
  ru: {
    name: "Имя",
    phone: "Номер телефона",
    comment: "Комментарии",
    submit: "Отправить",
    searchCountry: "Поиск страны...",
    notFound: "Не найдено",
    rateLimitError: "Вы можете попробовать только 2 раза за 30 минут!",
    titlePolite: "ХОТИТЕ",
    titleInformal: "Хочешь",
    titleHighlight: "Английский?",
    descriptionPolite:
      "Тогда отправьте свой номер и мы перезвоним чтобы ответить на все вопросы.",
    descriptionInformal:
      "Тогда отправь свой номер и мы перезвоним чтобы ответить на все вопросы.",
  },
  en: {
    name: "Your name",
    phone: "Phone number",
    comment: "Comment",
    submit: "Submit",
    searchCountry: "Search country...",
    notFound: "Not found",
    rateLimitError: "You can try only 2 times in 30 minutes!",
  },
} as const;
